<script>
export default {
  name: 'SelectDropDownModal',
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
  },
  data() {
    return {
      list: [],
      selected: null,
      resolvePromise: null,
      rejectPromise: null,
    };
  },
  methods: {
    show(list, defaultValue = null) {
      return new Promise((resolve, reject) => {
        this.list = [{ key: null, name: 'None' }, ...list];

        this.selected = defaultValue;

        this.$bvModal.show(this.id);

        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
  },
};
</script>

<template>
  <b-modal
    :id="id"
    style="z-index: 9999"
    @cancel="resolvePromise({ canceled: true })"
    @ok="resolvePromise({ canceled: false, selected })"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :hide-header="true"
  >
    <h2>{{ title }}</h2>
    <b-form-select
      v-model="selected"
      :options="list"
      text-field="name"
      value-field="key"
      size="lg"
    >
    </b-form-select>
  </b-modal>
</template>

<style scoped></style>
